module.exports = __webpack_public_path__ + "media/images/emblems/Homberg-coat_of_arms-2461a14db94f6668d9f036f5b50aa089.svg";